import { render, staticRenderFns } from "./taskFollow.vue?vue&type=template&id=014f10f4&scoped=true&"
import script from "./taskFollow.vue?vue&type=script&lang=js&"
export * from "./taskFollow.vue?vue&type=script&lang=js&"
import style0 from "./taskFollow.vue?vue&type=style&index=0&id=014f10f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f10f4",
  null
  
)

export default component.exports